import { useState } from "react"

/**
 * Hook personalizado para gestionar el estado de un formulario de forma controlada.
 * 
 * Estructura del retorno:
 * [0] values: Objeto con los valores actuales del formulario.
 * [1] handleInputChange: Función para actualizar campos basada en eventos de input.
 * [2] handleDirectInputChange: Función para actualizar campos pasando name y value directamente.
 * [3] setAllInfo: Función para sobrescribir todo el objeto de valores.
 * [4] reset: Reinicia todos los valores al estado inicial.
 * [5] resetExcept: Reinicia todos los valores excepto los campos indicados.
 *
 * Uso recomendado:
 * const [values, handleInputChange, handleDirectInputChange, setAllInfo, reset, resetExcept] = useForm(initialState);
 */
export const useForm = (initialState = {}) => {
    const [values, setValues] = useState(initialState);

    const reset = () => setValues(initialState);

    const resetExcept = (fieldsToKeep = []) => {
        setValues(prev => {
            const preserved = {};
            fieldsToKeep.forEach(key => {
                preserved[key] = prev[key];
            });
            return { ...initialState, ...preserved };
        });
    };

    const setAllInfo = (obj) => setValues(obj);

    const handleInputChange = (event) => {
        const { name, value, type, checked } = event.target;
        let newValue = value;
        if (type === 'number') {
            if (/^0[0-9]+/.test(value)) {
                newValue = parseFloat(value).toString();
            }
        }
        setValues(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : newValue
        }));
    };


    const handleDirectInputChange = (name, value) => {
        if (typeof name === 'object' && name !== null && value === undefined) {
            setValues((prevValueInputs) => ({
                ...prevValueInputs,
                ...name
            }));
            return;
        }
        setValues((prevValueInputs) => ({
            ...prevValueInputs,
            [name]: value
        }));
    }

    return [values, handleInputChange, handleDirectInputChange, setAllInfo, reset, resetExcept];
}
